import type { ComponentRegistry } from '@vibesites/runtime';
import {
  Header,
  Hero,
  PropertyOverview,
  SpecialOffers,
  CTASection,
  NeighborhoodSection,
  FloorplansList,
  AmenitiesList,
  PhotoGallery,
  NeighborhoodMap,
  VirtualTourEmbed,
  ContactForm,
  ContactUs,
  ContactMap,
  ScheduleTourForm,
  Fees,
  PetPolicy,
  FAQList,
  PageHero,
  PageBlurb,
  HeroSolidBG,
  Reviews,
  ReviewsCallout,
  SocialFollow,
  SpecialOfferBanner,
  ResidentAccess,
  ApplyNow,
  AccessibilityStatement,
  FairHousingContent,
  PrivacyPolicyContent,
  SitemapContent,
  HyperlocalHero,
  HyperlocalPageCopy,
  ThankYouContent,
  FutureResidentsClub,
  ApartmentSyncSection,
  Footer,
  Navigation,
  InteractiveMapSection,
} from './components';

export const registry: ComponentRegistry = {
  Header,
  Hero,
  PropertyOverview,
  SpecialOffers,
  CTASection,
  NeighborhoodSection,
  FloorplansList,
  AmenitiesList,
  PhotoGallery,
  NeighborhoodMap,
  VirtualTourEmbed,
  ContactForm,
  ContactUs,
  ContactMap,
  ScheduleTourForm,
  Fees,
  PetPolicy,
  FAQList,
  PageHero,
  PageBlurb,
  HeroSolidBG,
  Reviews,
  ReviewsCallout,
  SocialFollow,
  SpecialOfferBanner,
  ResidentAccess,
  ApplyNow,
  AccessibilityStatement,
  FairHousingContent,
  PrivacyPolicyContent,
  SitemapContent,
  HyperlocalHero,
  HyperlocalPageCopy,
  ThankYouContent,
  FutureResidentsClub,
  ApartmentSyncSection,
  Footer,
  Navigation,
  InteractiveMapSection,
};

export default registry;
